// extracted by mini-css-extract-plugin
export var paragraph = "Page404-module--paragraph--2457c";